<template>
  <div class="card mb-5">
    <div class="card-header">
      <h2>Demande d'informations</h2>
      <span class="small-title">
        Nous avons besoin de plus d'informations pour répondre à cet avis.
      </span>
    </div>
    <EstablishmentStateComments
      :comments="state && state.data ? state.data.comments : []"
      @comments:added="update_data"
    />
  </div>
</template>

<script>
import UPDATE_STATE_DATA from '@/gql/mutations/updateStateData.graphql';
import STATE_CALL_ACTION from '@/gql/mutations/stateCallAction.graphql';
import { gqlMutation } from '@/gqlClient.js';
import tools from "@/tools.js"
import StateComments from "@/components/StateComments.vue"
import EstablishmentStateComments from '@/components/EstablishmentStateComments'

export default {
  name: "EstablishmentStateWaintingForInformation",
  components: { StateComments, EstablishmentStateComments },
  props: {
    review: Object,
    establishment: Object,
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actions: {},
      state: null,
      show_native_lang_content: false
    }
  },
  methods: {
    update_data(comments) {
      if (this.state && this.state.data) {
        this.state.data.comments = comments
        var serialized = JSON.stringify(this.state.data)
        serialized = tools.b64_encode(serialized)
        gqlMutation(UPDATE_STATE_DATA, { uid: this.state.uid, serialized: serialized })
      }
    },
    async call_action(slug) {
      var self = this
      var data = await gqlMutation(STATE_CALL_ACTION, { uid: self.review.current_state.uid, action_slug: slug })
      this.$router.push("/")
    }
  },
  created() {
    var self = this
    // convert action list to object & keep only establishment ones
    if (self.review && self.review.current_state && self.review.current_state.list_actions) {
      self.review.current_state.list_actions.forEach(function(action) {
        if (action.groups && action.groups.indexOf("establishment") !== -1) {
          self.actions[action.slug] = action
        }
      })
    }
    if (self.review && self.review.current_state) {
      self.state = self.review.current_state
      if (self.state.data) {
        if (typeof self.state.data === "string") {
          self.state.data = JSON.parse(self.state.data)
        }
      }
    }
    if (self.$djangows && self.$djangows.onmodelsignals) {
      self.$djangows.onmodelsignals(
        { modelName: "state", appLabel: "state" },
        function(event) {
          if (event.obj) {
            if (event.obj.review === self.review.uid) {
              if (event.signal_type === "post_save" && event.created === false) {
                if (self.state && self.state.data && event.obj.data && event.obj.data.comments) {
                  self.state.data.comments = event.obj.data.comments
                }
              }
            }
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  h2{
     font-size:23px;
  }
</style>